<header class="flex flex-col absolute inset-x-0 w-full mt-2 md:mt-0 z-40">
  <section class="w-full h-16 flex items-center justify-between px-8 sm:px-12 sm:h-20 min-w-0">
    <img
      class="w-32 md:w-44 cursor-pointer"
      src="assets/images/clarios-logo.svg"
      alt="Clarios Logo"
      (click)="navigateTo('main/documents/comparison/compare')"
    />
    
    @if (!isLargeScreen) {
      <button
        class="menu-icon"
        [class.open]="isOpen"
        (click)="toggleHamburgerMenu()"
        aria-label="Toggle menu"
        type="button"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
    }
    @if (isLargeScreen) {
      <nav>
        <ng-container
          *ngTemplateOutlet="headerItem; context: { class: 'text-sm text-lDisabled font-medium whitespace-nowrap flex justify-start gap-5' }"
        />
      </nav>
      
      <div class="relative flex justify-end items-center w-32 md:w-44">
        <l-initial-circle
          [name]="username()?.username"
          [hasModal]="true"
          [modalActions]="modalActions"
          class="cursor-pointer select-none menu-options-animate mr-3"
          style="animation-delay: 0.18s;"
        />
      </div>
    }
  </section>

  @if (isOpen && !isLargeScreen) {
    <div
      class="w-screen h-[calc(100vh-4.6rem)] flex flex-col justify-between py-6 px-5 sm:py-10 sm:px-8 z-50 sm:h-[calc(100vh-5.1rem)] border-b border-gray-300"
      [ngClass]="foreground() ? 'foreground' : 'background'"
    >
      <nav>
        <ng-container
          *ngTemplateOutlet="headerItem; context: { class: 'flex flex-col items-start gap-4 text-sm text-lDisabled text-start font-medium md:text-base mobile-nav-item' }"
        />
      </nav>

      <div class="flex flex-col gap-6 text-lPrimary">
        <div class="flex gap-2 items-center menu-options-animate" style="animation-delay: 0.27s;">
          <l-initial-circle [name]="username()?.username" class="cursor-pointer select-none" />
          <span>{{username()?.username}}</span>
        </div>
        
        <ul class="flex flex-col gap-3" role="menu">
          @for (action of modalActions; track action.label; let i = $index) {
            <li
              class="flex justify-between items-center cursor-pointer hover:opacity-80 menu-options-animate"
              [ngClass]="action.colorClass"
              (click)="handleAction(action, $event)"
              [style.animation-delay]="(i * 0.09) + 's'"
              role="menuitem"
            >
              <span>{{ action.label }}</span>
              <l-icon>{{ action.icon }}</l-icon>
            </li>
          }
        </ul>
      </div>
    </div>
  }

  <ng-template #headerItem let-class="class">
    <ol [ngClass]="class">
      @for (item of headerItens; track item.key; let i = $index) {
        <div
          class="transition-all duration-300 pb-1 text-center shrink-0 sm:shrink menu-options-animate"
          [ngClass]="{ 'border-b-2 border-lPurple700 title-color font-semibold': i === activatedIndex() }"
          (click)="toggleHeader(i)"
          [style.animation-delay]="(i * 0.09) + 's'"
        >
          <a class="block" [routerLink]="'/' + item.link">
            {{ item.title }}
          </a>
        </div>
      }
    </ol>
  </ng-template>
</header>
